import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaToastComponent} from './la-toast.component';
import {LaIconModule, LaTextModule} from '..';

@NgModule({
  imports: [
    CommonModule,
    LaIconModule,
    LaTextModule
  ],
  declarations: [LaToastComponent],
  exports: [LaToastComponent]
})
export class LaToastModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaToastModule,
      providers: []
    };
  }
}
